import FrequentQue from "@/Components/CustomerLanding/CustomerFAQ";
import CustomerHero from "@/Components/CustomerLanding/CustomerHero";
import Footer from "@/Components/Landing/Footer";
import StepsGuide from "@/Components/Landing/HowItWorks";
import Navbar from "@/Components/Landing/Navbar";

const Customer = () => {
  return (
    <>
      <Navbar />
      <CustomerHero />
      <StepsGuide />
      <FrequentQue />
      <Footer />
    </>
  );
};

export default Customer;
